import { Component, Input } from '@angular/core';
import { LabelComponent } from '../../../../../../../../common/label/label.component';
import {
  ApplicantAppEntityApplicantWrite, ApplicantAppEntityApplicationRead,
  ContractorAppEntityContractorRead,
  ContractorAppEntityContractorWrite
} from '../../../../../../../../openapi';

@Component({
  selector: 'app-opinion-on-issuing-a-decision-investor-item-preview',
  standalone: true,
  imports: [
    LabelComponent
  ],
  templateUrl: './opinion-on-issuing-a-decision-investor-item-preview.component.html'
})
export class OpinionOnIssuingADecisionInvestorItemPreviewComponent {
  @Input()
  public investor: ApplicantAppEntityApplicantWrite | ApplicantAppEntityApplicationRead | undefined;
}
